var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8786 42.7572C33.4095 42.7572 42.7572 33.4095 42.7572 21.8786C42.7572 10.3477 33.4095 1 21.8786 1C10.3477 1 1 10.3477 1 21.8786C1 33.4095 10.3477 42.7572 21.8786 42.7572Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 53.8786C44.5314 53.8786 53.879 44.5309 53.879 32.9999C53.879 21.469 44.5314 12.1213 33.0004 12.1213C21.4695 12.1213 12.1218 21.469 12.1218 32.9999C12.1218 44.5309 21.4695 53.8786 33.0004 53.8786Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1213 65C55.6522 65 64.9999 55.6523 64.9999 44.1214C64.9999 32.5905 55.6522 23.2428 44.1213 23.2428C32.5903 23.2428 23.2427 32.5905 23.2427 44.1214C23.2427 55.6523 32.5903 65 44.1213 65Z",
    fill: "#845EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.ea120e597bcaf0c7320a809f4292904d.svg";
export { ForwardRef as ReactComponent };